/**
 * Sale-catalogue filter constants — shared across hooks and components that
 * read or write the sale-date filter from the URL.
 */

export const SALE_DATE_FILTER = {
  CURRENT: 'current',
  ALL: 'all',
} as const;

export type SaleDateFilter =
  (typeof SALE_DATE_FILTER)[keyof typeof SALE_DATE_FILTER];

/** Sortable / filterable fields on the sale-catalogue GraphQL query. */
export const SALE_FILTER_FIELD = {
  PUBLISH_TILL_DATE: 'PUBLISH_TILL_DATE',
} as const;
